import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/logos/sidebarlogo.png'


const _hoisted_1 = { class: "logo bg-white dark:bg-[#0c1427] border-b border-gray-100 dark:border-[#172036] px-[25px] pt-[19px] pb-[15px] absolute z-[2] right-0 top-0 left-0" }
const _hoisted_2 = { class: "pt-[89px] px-[25px] pb-[20px] h-[calc(100vh-89px)] overflow-y-auto rounded-md" }
const _hoisted_3 = { class: "accordion" }
const _hoisted_4 = {
  class: "block relative font-medium uppercase text-gray-400 mb-[8px] text-xs",
  "data-i18n-key": "sidebar.main"
}
const _hoisted_5 = { class: "accordion-item rounded-md text-black dark:text-white mb-[5px] whitespace-nowrap" }
const _hoisted_6 = {
  class: "accordion-button toggle flex items-center transition-all py-[9px] ltr:pl-[14px] ltr:pr-[30px] rtl:pr-[14px] rtl:pl-[30px] rounded-md font-medium w-full relative hover:bg-gray-50 text-left dark:hover:bg-[#15203c]",
  type: "button"
}
const _hoisted_7 = {
  class: "title leading-none",
  "data-i18n-key": "sidebar.dashboards"
}
const _hoisted_8 = { class: "accordion-collapse hidden" }
const _hoisted_9 = { class: "pt-[4px]" }
const _hoisted_10 = { class: "sidebar-sub-menu" }
const _hoisted_11 = {
  key: 0,
  class: "sidemenu-item mb-[4px] last:mb-0"
}
const _hoisted_12 = { "data-i18n-key": "sidebar.ecommerce" }
const _hoisted_13 = {
  key: 1,
  class: "sidemenu-item mb-[4px] last:mb-0"
}
const _hoisted_14 = { "data-i18n-key": "sidebar.crm" }
const _hoisted_15 = {
  class: "block relative font-medium uppercase text-gray-400 mb-[8px] text-xs [&:not(:first-child)]:mt-[22px]",
  "data-i18n-key": "sidebar.apps"
}
const _hoisted_16 = { class: "accordion-item rounded-md text-black dark:text-white mb-[5px] whitespace-nowrap" }
const _hoisted_17 = {
  class: "title leading-none",
  "data-i18n-key": "sidebar.todoList"
}
const _hoisted_18 = { class: "accordion-item rounded-md text-black dark:text-white mb-[5px] whitespace-nowrap" }
const _hoisted_19 = {
  class: "title leading-none",
  "data-i18n-key": "sidebar.calendar"
}
const _hoisted_20 = { class: "accordion-item rounded-md text-black dark:text-white mb-[5px] whitespace-nowrap" }
const _hoisted_21 = {
  class: "title leading-none",
  "data-i18n-key": "sidebar.chat"
}
const _hoisted_22 = { class: "accordion-item rounded-md text-black dark:text-white mb-[5px] whitespace-nowrap" }
const _hoisted_23 = {
  class: "title leading-none",
  "data-i18n-key": "sidebar.contacts"
}
const _hoisted_24 = {
  class: "block relative font-medium uppercase text-gray-400 mb-[8px] text-xs [&:not(:first-child)]:mt-[22px]",
  "data-i18n-key": "sidebar.pages"
}
const _hoisted_25 = {
  key: 0,
  class: "accordion-item rounded-md text-black dark:text-white mb-[5px] whitespace-nowrap"
}
const _hoisted_26 = {
  class: "accordion-button toggle flex items-center transition-all py-[9px] ltr:pl-[14px] ltr:pr-[30px] rtl:pr-[14px] rtl:pl-[30px] rounded-md font-medium w-full relative hover:bg-gray-50 text-left dark:hover:bg-[#15203c]",
  type: "button"
}
const _hoisted_27 = {
  class: "title leading-none",
  "data-i18n-key": "sidebar.ecommerce"
}
const _hoisted_28 = { class: "accordion-collapse hidden" }
const _hoisted_29 = { class: "pt-[4px]" }
const _hoisted_30 = { class: "sidebar-sub-menu" }
const _hoisted_31 = { class: "sidemenu-item mb-[4px] last:mb-0" }
const _hoisted_32 = { "data-i18n-key": "sidebar.productsGrid" }
const _hoisted_33 = { class: "sidemenu-item mb-[4px] last:mb-0" }
const _hoisted_34 = { "data-i18n-key": "sidebar.productsList" }
const _hoisted_35 = { class: "sidemenu-item mb-[4px] last:mb-0" }
const _hoisted_36 = { "data-i18n-key": "sidebar.customers" }
const _hoisted_37 = { class: "sidemenu-item mb-[4px] last:mb-0" }
const _hoisted_38 = { "data-i18n-key": "sidebar.orders" }
const _hoisted_39 = {
  key: 1,
  class: "accordion-item rounded-md text-black dark:text-white mb-[5px] whitespace-nowrap"
}
const _hoisted_40 = {
  class: "accordion-button toggle flex items-center transition-all py-[9px] ltr:pl-[14px] ltr:pr-[30px] rtl:pr-[14px] rtl:pl-[30px] rounded-md font-medium w-full relative hover:bg-gray-50 text-left dark:hover:bg-[#15203c]",
  type: "button"
}
const _hoisted_41 = {
  class: "title leading-none",
  "data-i18n-key": "sidebar.crm"
}
const _hoisted_42 = { class: "accordion-collapse hidden" }
const _hoisted_43 = { class: "pt-[4px]" }
const _hoisted_44 = { class: "sidebar-sub-menu" }
const _hoisted_45 = { class: "sidemenu-item mb-[4px] last:mb-0" }
const _hoisted_46 = { "data-i18n-key": "sidebar.leads" }
const _hoisted_47 = { class: "sidemenu-item mb-[4px] last:mb-0" }
const _hoisted_48 = { "data-i18n-key": "sidebar.customers" }
const _hoisted_49 = { class: "sidemenu-item mb-[4px] last:mb-0" }
const _hoisted_50 = { "data-i18n-key": "sidebar.deals" }
const _hoisted_51 = { class: "sidemenu-item mb-[4px] last:mb-0" }
const _hoisted_52 = { "data-i18n-key": "sidebar.productsGrid" }
const _hoisted_53 = { class: "sidemenu-item mb-[4px] last:mb-0" }
const _hoisted_54 = { "data-i18n-key": "sidebar.productsList" }
const _hoisted_55 = {
  key: 2,
  class: "accordion-item rounded-md text-black dark:text-white mb-[5px] whitespace-nowrap"
}
const _hoisted_56 = {
  class: "accordion-button toggle flex items-center transition-all py-[9px] ltr:pl-[14px] ltr:pr-[30px] rtl:pr-[14px] rtl:pl-[30px] rounded-md font-medium w-full relative hover:bg-gray-50 text-left dark:hover:bg-[#15203c]",
  type: "button"
}
const _hoisted_57 = {
  class: "title leading-none",
  "data-i18n-key": "sidebar.realEstate"
}
const _hoisted_58 = { class: "accordion-collapse hidden" }
const _hoisted_59 = { class: "pt-[4px]" }
const _hoisted_60 = { class: "sidebar-sub-menu" }
const _hoisted_61 = { class: "sidemenu-item mb-[4px] last:mb-0" }
const _hoisted_62 = { "data-i18n-key": "sidebar.propertyList" }
const _hoisted_63 = { class: "sidemenu-item mb-[4px] last:mb-0" }
const _hoisted_64 = { "data-i18n-key": "sidebar.addProperty" }
const _hoisted_65 = {
  class: "block relative font-medium uppercase text-gray-400 mb-[8px] text-xs [&:not(:first-child)]:mt-[22px]",
  "data-i18n-key": "sidebar.others"
}
const _hoisted_66 = { class: "accordion-item rounded-md text-black dark:text-white mb-[5px] whitespace-nowrap" }
const _hoisted_67 = {
  class: "title leading-none",
  "data-i18n-key": "sidebar.members"
}
const _hoisted_68 = { class: "accordion-item rounded-md text-black dark:text-white mb-[5px] whitespace-nowrap" }
const _hoisted_69 = {
  class: "accordion-button toggle flex items-center transition-all py-[9px] ltr:pl-[14px] ltr:pr-[30px] rtl:pr-[14px] rtl:pl-[30px] rounded-md font-medium w-full relative hover:bg-gray-50 text-left dark:hover:bg-[#15203c]",
  type: "button"
}
const _hoisted_70 = {
  class: "title leading-none",
  "data-i18n-key": "common.settings"
}
const _hoisted_71 = { class: "accordion-collapse hidden" }
const _hoisted_72 = { class: "pt-[4px]" }
const _hoisted_73 = { class: "sidebar-sub-menu" }
const _hoisted_74 = { class: "sidemenu-item mb-[4px] last:mb-0" }
const _hoisted_75 = { "data-i18n-key": "sidebar.accountSettings" }
const _hoisted_76 = { class: "sidemenu-item mb-[4px] last:mb-0" }
const _hoisted_77 = { "data-i18n-key": "sidebar.changePassword" }
const _hoisted_78 = { class: "sidemenu-item mb-[4px] last:mb-0" }
const _hoisted_79 = { "data-i18n-key": "sidebar.connections" }
const _hoisted_80 = { class: "absolute bottom-0 left-0 right-0 bg-white dark:bg-[#0c1427] pb-[15px] px-[25px]" }
const _hoisted_81 = { class: "accordion-item rounded-md text-black dark:text-white mb-[5px] whitespace-nowrap" }
const _hoisted_82 = {
  class: "title leading-none",
  style: {"color":"#ff0000 !important"},
  "data-i18n-key": "common.logout"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      ref: "sidebarRef",
      class: _normalizeClass([
      'sidebar-area bg-white dark:bg-[#0c1427] fixed z-[8] top-0 h-screen transition-all rounded-r-md',
      { active: _ctx.stateStoreInstance.open },
    ])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_RouterLink, {
          to: "/dashboard",
          class: "transition-none relative flex items-center justify-center"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "logo",
              class: "h-10"
            }, null, -1)
          ])),
          _: 1
        }),
        (_ctx.isMobile())
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "close-sidebar-btn inline-block absolute z-[10] top-[24px] ltr:right-[25px] rtl:left-[25px] transition-all hover:text-primary-500",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeSidebar && _ctx.closeSidebar(...args)))
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "material-symbols-outlined !text-[22px]" }, " close ", -1)
            ])))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.directT('sidebar.main')), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", _hoisted_6, [
              _cache[3] || (_cache[3] = _createElementVNode("i", { class: "material-symbols-outlined transition-all text-gray-500 dark:text-gray-400 ltr:mr-[7px] rtl:ml-[7px] !text-[22px] leading-none relative -top-px" }, " dashboard ", -1)),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.directT('sidebar.dashboards')), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("ul", _hoisted_10, [
                  (_ctx.shouldShowEcommerceDashboard)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                        _createVNode(_component_RouterLink, {
                          to: "/dashboard",
                          class: "sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]",
                          onClick: _ctx.handleNavigation
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.directT('sidebar.ecommerce')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.shouldShowCRMDashboard)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                        _createVNode(_component_RouterLink, {
                          to: "/dashboard/crm",
                          class: "sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]",
                          onClick: _ctx.handleNavigation
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.directT('sidebar.crm')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.directT('sidebar.apps')), 1),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_RouterLink, {
              to: "/apps/to-do-list",
              class: "accordion-button flex items-center transition-all py-[9px] ltr:pl-[14px] ltr:pr-[30px] rtl:pr-[14px] rtl:pl-[30px] rounded-md font-medium w-full relative hover:bg-gray-50 text-left dark:hover:bg-[#15203c]",
              onClick: _ctx.handleNavigation
            }, {
              default: _withCtx(() => [
                _cache[4] || (_cache[4] = _createElementVNode("i", { class: "material-symbols-outlined transition-all text-gray-500 dark:text-gray-400 ltr:mr-[7px] rtl:ml-[7px] !text-[22px] leading-none relative -top-px" }, " format_list_bulleted ", -1)),
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.directT('sidebar.todoList')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_RouterLink, {
              to: "/apps/calendar",
              class: "accordion-button flex items-center transition-all py-[9px] ltr:pl-[14px] ltr:pr-[30px] rtl:pr-[14px] rtl:pl-[30px] rounded-md font-medium w-full relative hover:bg-gray-50 text-left dark:hover:bg-[#15203c]",
              onClick: _ctx.handleNavigation
            }, {
              default: _withCtx(() => [
                _cache[5] || (_cache[5] = _createElementVNode("i", { class: "material-symbols-outlined transition-all text-gray-500 dark:text-gray-400 ltr:mr-[7px] rtl:ml-[7px] !text-[22px] leading-none relative -top-px" }, " date_range ", -1)),
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.directT('sidebar.calendar')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_RouterLink, {
              to: "/apps/chat",
              class: "accordion-button flex items-center transition-all py-[9px] ltr:pl-[14px] ltr:pr-[30px] rtl:pr-[14px] rtl:pl-[30px] rounded-md font-medium w-full relative hover:bg-gray-50 text-left dark:hover:bg-[#15203c]",
              onClick: _ctx.handleNavigation
            }, {
              default: _withCtx(() => [
                _cache[6] || (_cache[6] = _createElementVNode("i", { class: "material-symbols-outlined transition-all text-gray-500 dark:text-gray-400 ltr:mr-[7px] rtl:ml-[7px] !text-[22px] leading-none relative -top-px" }, " chat ", -1)),
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.directT('sidebar.chat')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_RouterLink, {
              to: "/apps/contacts",
              class: "accordion-button flex items-center transition-all py-[9px] ltr:pl-[14px] ltr:pr-[30px] rtl:pr-[14px] rtl:pl-[30px] rounded-md font-medium w-full relative hover:bg-gray-50 text-left dark:hover:bg-[#15203c]",
              onClick: _ctx.handleNavigation
            }, {
              default: _withCtx(() => [
                _cache[7] || (_cache[7] = _createElementVNode("i", { class: "material-symbols-outlined transition-all text-gray-500 dark:text-gray-400 ltr:mr-[7px] rtl:ml-[7px] !text-[22px] leading-none relative -top-px" }, " contacts ", -1)),
                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.directT('sidebar.contacts')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.directT('sidebar.pages')), 1),
          (_ctx.shouldShowEcommerceMenu)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("button", _hoisted_26, [
                  _cache[8] || (_cache[8] = _createElementVNode("i", { class: "material-symbols-outlined transition-all text-gray-500 dark:text-gray-400 ltr:mr-[7px] rtl:ml-[7px] !text-[22px] leading-none relative -top-px" }, " shopping_cart ", -1)),
                  _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.directT('sidebar.ecommerce')), 1)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("ul", _hoisted_30, [
                      _createElementVNode("li", _hoisted_31, [
                        _createVNode(_component_RouterLink, {
                          to: "/ecommerce/products-grid",
                          class: "sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]",
                          onClick: _ctx.handleNavigation
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.directT('sidebar.productsGrid')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _createElementVNode("li", _hoisted_33, [
                        _createVNode(_component_RouterLink, {
                          to: "/ecommerce/products-list",
                          class: "sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]",
                          onClick: _ctx.handleNavigation
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.directT('sidebar.productsList')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _createElementVNode("li", _hoisted_35, [
                        _createVNode(_component_RouterLink, {
                          to: "/crm/customers",
                          class: "sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]",
                          onClick: _ctx.handleNavigation
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.directT('sidebar.customers')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _createElementVNode("li", _hoisted_37, [
                        _createVNode(_component_RouterLink, {
                          to: "/ecommerce/orders",
                          class: "sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]",
                          onClick: _ctx.handleNavigation
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.directT('sidebar.orders')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.shouldShowCRMMenu)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createElementVNode("button", _hoisted_40, [
                  _cache[9] || (_cache[9] = _createElementVNode("i", { class: "material-symbols-outlined transition-all text-gray-500 dark:text-gray-400 ltr:mr-[7px] rtl:ml-[7px] !text-[22px] leading-none relative -top-px" }, " business_chip ", -1)),
                  _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.directT('sidebar.crm')), 1)
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("ul", _hoisted_44, [
                      _createElementVNode("li", _hoisted_45, [
                        _createVNode(_component_RouterLink, {
                          to: "/crm/leads",
                          class: "sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]",
                          onClick: _ctx.handleNavigation
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.directT('sidebar.leads')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _createElementVNode("li", _hoisted_47, [
                        _createVNode(_component_RouterLink, {
                          to: "/crm/customers",
                          class: "sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]",
                          onClick: _ctx.handleNavigation
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.directT('sidebar.customers')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _createElementVNode("li", _hoisted_49, [
                        _createVNode(_component_RouterLink, {
                          to: "/crm/deals",
                          class: "sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]",
                          onClick: _ctx.handleNavigation
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.directT('sidebar.deals')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _createElementVNode("li", _hoisted_51, [
                        _createVNode(_component_RouterLink, {
                          to: "/ecommerce/products-grid",
                          class: "sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]",
                          onClick: _ctx.handleNavigation
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.directT('sidebar.productsGrid')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _createElementVNode("li", _hoisted_53, [
                        _createVNode(_component_RouterLink, {
                          to: "/ecommerce/products-list",
                          class: "sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]",
                          onClick: _ctx.handleNavigation
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.directT('sidebar.productsList')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.shouldShowRealEstateMenu)
            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                _createElementVNode("button", _hoisted_56, [
                  _cache[10] || (_cache[10] = _createElementVNode("i", { class: "material-symbols-outlined transition-all text-gray-500 dark:text-gray-400 ltr:mr-[7px] rtl:ml-[7px] !text-[22px] leading-none relative -top-px" }, " real_estate_agent ", -1)),
                  _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.directT('sidebar.realEstate')), 1)
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("ul", _hoisted_60, [
                      _createElementVNode("li", _hoisted_61, [
                        _createVNode(_component_RouterLink, {
                          to: "/real-estate/property-list",
                          class: "sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]",
                          onClick: _ctx.handleNavigation
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.directT('sidebar.propertyList')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _createElementVNode("li", _hoisted_63, [
                        _createVNode(_component_RouterLink, {
                          to: "/real-estate/add-property",
                          class: "sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]",
                          onClick: _ctx.handleNavigation
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.directT('sidebar.addProperty')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.directT('sidebar.others')), 1),
          _createElementVNode("div", _hoisted_66, [
            _createVNode(_component_RouterLink, {
              to: "/members",
              class: "accordion-button flex items-center transition-all py-[9px] ltr:pl-[14px] ltr:pr-[30px] rtl:pr-[14px] rtl:pl-[30px] rounded-md font-medium w-full relative hover:bg-gray-50 text-left dark:hover:bg-[#15203c]",
              onClick: _ctx.handleNavigation
            }, {
              default: _withCtx(() => [
                _cache[11] || (_cache[11] = _createElementVNode("i", { class: "material-symbols-outlined transition-all text-gray-500 dark:text-gray-400 ltr:mr-[7px] rtl:ml-[7px] !text-[22px] leading-none relative -top-px" }, " people ", -1)),
                _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.directT('sidebar.members')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("button", _hoisted_69, [
              _cache[12] || (_cache[12] = _createElementVNode("i", { class: "material-symbols-outlined transition-all text-gray-500 dark:text-gray-400 ltr:mr-[7px] rtl:ml-[7px] !text-[22px] leading-none relative -top-px" }, " settings ", -1)),
              _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.directT('common.settings')), 1)
            ]),
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("ul", _hoisted_73, [
                  _createElementVNode("li", _hoisted_74, [
                    _createVNode(_component_RouterLink, {
                      to: "/settings/account-settings",
                      class: "sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]",
                      onClick: _ctx.handleNavigation
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.directT('sidebar.accountSettings')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _createElementVNode("li", _hoisted_76, [
                    _createVNode(_component_RouterLink, {
                      to: "/settings/change-password",
                      class: "sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]",
                      onClick: _ctx.handleNavigation
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.directT('sidebar.changePassword')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _createElementVNode("li", _hoisted_78, [
                    _createVNode(_component_RouterLink, {
                      to: "/settings/connections",
                      class: "sidemenu-link rounded-md flex items-center relative transition-all font-medium text-gray-500 dark:text-gray-400 py-[9px] ltr:pl-[38px] ltr:pr-[30px] rtl:pr-[38px] rtl:pl-[30px] hover:text-primary-500 hover:bg-primary-50 w-full text-left dark:hover:bg-[#15203c]",
                      onClick: _ctx.handleNavigation
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.directT('sidebar.connections')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_80, [
          _createElementVNode("div", _hoisted_81, [
            _createVNode(_component_RouterLink, {
              to: "/authentication/logout",
              class: "accordion-button flex items-center transition-all py-[9px] ltr:pl-[14px] ltr:pr-[30px] rtl:pr-[14px] rtl:pl-[30px] rounded-md font-medium w-full relative hover:bg-red-100 text-red-600 bg-red-50 dark:bg-[#2A1515] font-bold text-left dark:hover:bg-red-900/20 dark:text-red-500",
              style: {"color":"#ff0000 !important"},
              onClick: _ctx.handleNavigation
            }, {
              default: _withCtx(() => [
                _cache[13] || (_cache[13] = _createElementVNode("i", {
                  class: "material-symbols-outlined transition-all ltr:mr-[7px] rtl:ml-[7px] !text-[22px] leading-none relative -top-px",
                  style: {"color":"#ff0000 !important"}
                }, " logout ", -1)),
                _createElementVNode("span", _hoisted_82, _toDisplayString(_ctx.directT('common.logout')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ])
    ], 2),
    (!_ctx.stateStoreInstance.open && _ctx.isMobile())
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([
      'swipe-indicator fixed top-1/2 -translate-y-1/2 z-[6] h-20 w-1.5 bg-primary-500/40 rounded-r-md transition-opacity',
      _ctx.isRTL ? 'right-0' : 'left-0'
    ])
        }, null, 2))
      : _createCommentVNode("", true)
  ], 64))
}